import { render, staticRenderFns } from "./AddGymRoutesToPublicationModal.vue?vue&type=template&id=1aef4b0b"
import script from "./AddGymRoutesToPublicationModal.vue?vue&type=script&lang=js"
export * from "./AddGymRoutesToPublicationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports